import React from 'react';
import '../../../style/premiumSettingsWizard.css'

const ProgressBarItem = (props) => {
    let itemStyle;
    let labelStyle;
    let stepStyle;
    if (props.stepNumber === props.currentStep) {
        itemStyle = 'premiumSettingsWizardBarItem-active';
        labelStyle = 'premiumSettingsWizardBarItem-stepLabel-completed';
        stepStyle = 'premiumSettingsWizardBarItem-stepStyle-completed';
    }
    else if (props.stepNumber < props.currentStep) {
        itemStyle = 'premiumSettingsWizardBarItem-completed';
        labelStyle = 'premiumSettingsWizardBarItem-stepLabel-completed';
        stepStyle = 'premiumSettingsWizardBarItem-stepStyle-completed';
    }
    else if (props.stepNumber > props.currentStep) {
        itemStyle = 'premiumSettingsWizardBarItem-remaining';
        labelStyle = 'premiumSettingsWizardBarItem-stepLabel-remaining';
        stepStyle = 'premiumSettingsWizardBarItem-stepStyle-remaining';
    }
    return (
        <div className={"premiumSettingsWizardBarItem " + itemStyle}
             onClick={() => props.changeStepThroughProgressBar(props.stepNumber)}>
            <span className={stepStyle}>{props.stepNumber}</span>
            <span className={labelStyle}>{props.label}</span>
        </div>
    )
};

export default ProgressBarItem;